/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/RelatedProducts/RelatedProducts',[
    'jquery',
    'global/all',
    'modules/Cart/all',
    'plugins/slick',
    'modules/ProductLease/ProductLease.Forms'
], function ($, Roc, Cart, Slick, ProductLeaseForm) {
    'use strict';

    var btns = {
        addToCart: '[data-roc-action="addProductToCartBtn"]',
        productLeaseBtn: '[data-roc-action="relatedProductLease"]'
    };

    function init() {
        var carouselData = {
            animationSpeed: 1500,
            autoRotate: false,
            autoRotateSpeed: 1000,
            nofVisible: 4,
            scrollNumber: 1,
            showNextPrevButtons: true,
            isCircular: true,
            showDots: false
        };

        $('.hawk-recommendation-list').slick({
            speed: carouselData.animationSpeed,
            autoplay: carouselData.autoRotate,
            autoplaySpeed: carouselData.autoRotateSpeed,
            vertical: false,
            slidesToShow: carouselData.nofVisible,
            slidesToScroll: carouselData.scrollNumber,
            arrows: carouselData.showNextPrevButtons,
            nextArrow: '<button type="button" class="hawk-carousel-next"><span>Next</span></a>',
            prevArrow: '<button type="button" class="hawk-carousel-prev"><span>Previous</span></a>',
            infinite: carouselData.isCircular,
            dots: carouselData.autoRotateshowDots,
            //variableWidth: (!item.isVertical),
            slide: '.hawk-recommendation-item',
            pauseOnDotsHover: true,
            pauseOnHover: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        arrows: carouselData.showNextPrevButtons,
                        dots: carouselData.showDots
                    }
                },
                {
                    breakpoint: 860,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        arrows: carouselData.showNextPrevButtons,
                        dots: carouselData.showDots
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: carouselData.showNextPrevButtons
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: carouselData.showNextPrevButtons
                    }
                },
                {
                    breakpoint: 240,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: carouselData.showNextPrevButtons
                    }
                }
            ]
        });

        addToCartEvt();
    };

    function submitProductLease(event) {
        var isValid = Roc.Validation.validateForm(ProductLeaseForm.Productlease);
        if (isValid) {
            Roc.Core.lockButton("#quoteProducBtn");
            var requestData = Roc.Validation.getFieldValues(ProductLeaseForm.Productlease);
            requestData.Qty = $('#purchaseQuantity').val();
            requestData.Sku = $(event.target).attr('data-product-sku');
            $.proxyRequest({
                type: 'POST',
                url: '/api/store/productlease/submit/',
                data: JSON.stringify(requestData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                complete: function (xhr) {
                }
            });
            addToCartEvent(null, btns.addToCart);
        }
    }

    function addToCart() {
        var btnAddToCart = event.target;
        var productId = $(btnAddToCart).attr("data-roc-attribute");
        var source = $(btnAddToCart).attr("data-roc-source");
        var qtyControl;
        if (source === "relatedProduct") {
            qtyControl = $('#purchaseQuantity-' + productId);
        }
        else {
            qtyControl = $('#relatedProductPurchaseQuantity-' + productId);
        }

        var wantsQty = $(qtyControl).val();
        var qty = (!wantsQty || isNaN(wantsQty)) ? -1 : parseInt(wantsQty);

        if (isNaN(qty) || qty <= 0) {
            Roc.UI.displayErrorPopup('The quantity provided is invalid. Please enter a value greater than 0 and try again.');
            return;
        }

        var isLeaseProduct = $(event.target).attr('data-product-lease');
        if (isLeaseProduct && isLeaseProduct === 'True') {
            var leaseModel = {};
            leaseModel.name = $(event.target).attr('data-product-name');
            leaseModel.sku = $(event.target).attr('data-product-sku');
            Roc.UI.template('relatedProductLease-Tmp', leaseModel).then(function (renderedTemplate) {
                Roc.UI.Modal.open(renderedTemplate);
            });
        }

        else {
            addToCartEvent(event, null);
        }
    }

    function addToCartEvent(event, btn) {
        var btnAddToCart;
        if (btn === null) {
            btnAddToCart = event.target;
        }
        else {
            btnAddToCart = btn;
        }
        var productId = $(btnAddToCart).attr("data-roc-attribute");
        var uomId = $(btnAddToCart).attr("data-roc-uom");
        var qtyControl;
        var source = $(btnAddToCart).attr("data-roc-source");
        if (source === "relatedProduct") {
            qtyControl = $('#purchaseQuantity-' + productId);
        }
        else {
            qtyControl = $('#relatedProductPurchaseQuantity-' + productId);
        }
        var wantsQty = $(qtyControl).val();
        var qty = (!wantsQty || isNaN(wantsQty)) ? -1 : parseInt(wantsQty);
        var upchargeData = {};

        var request = {
            'productId': productId,
            'quantity': qty,
            'orderId': '{orderId}',
            'groupId': '',
            'uomId': uomId
        };

        Cart.CartLocker.isCartUnlocked()
            .then(function () {
                Roc.Core.lockButton(btnAddToCart);
                Cart.CartManager.addCartItem(
                    request.productId,
                    request.quantity,
                    request.groupId,
                    request.uomId,
                    null,
                    null,
                    null,
                    upchargeData);
                Roc.Core.releaseLockedButton(btns.addToCart);
            });
    }

    function addToCartEvt() {
        Roc.UI.siteBody
            .off('click', btns.addToCart)
            .on('click', btns.addToCart, function (e) {
                e.preventDefault();
                addToCart(e);
            });
        Roc.UI.siteBody
            .off('click', btns.productLeaseBtn)
            .on('click', btns.productLeaseBtn, function (e) {
                e.preventDefault();
                submitProductLease(e);
            });
    }

    var RelatedProducts = {
        init: init
    };

    Roc.Logger.debug('RelatedProducts.js Loaded:', RelatedProducts);

    return RelatedProducts;
});
